module.exports = __webpack_public_path__ + "static/media/kaci-baum-2.e06d84cb.jpg";